exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".board-cart-title a[data-v-44d72a7c]{color:#16181f;font-size:14px;font-weight:500;font-family:Fira Sans,sans-serif;padding:7px 13px;display:block;height:100%}.input-axis[data-v-44d72a7c]{font-size:18px;font-weight:500;color:#16181f;border:none;text-align:center}.x-axis[data-v-44d72a7c]{margin-top:10px}span.y-axis-span[data-v-44d72a7c]{max-width:40px;margin-right:0}.y-axis[data-v-44d72a7c]{height:45px;overflow-y:auto;transform:rotate(270deg);left:0;margin-left:-75px}.container-fluid[data-v-44d72a7c]{margin-bottom:30px}", ""]);

// exports
